// Country-level metadata used by the Variants directory and Rules library.
import { COUNTRY_GROUPS, RULESETS, STATUS } from "@/game/rulesets";

export const COUNTRIES = [
  {
    slug: "zimbabwe",
    name: "Zimbabwe",
    flag: "🇿🇼",
    region: "Southern Africa",
    blurb:
      "The home of Tsoro (also called Fuva or Imbwe). Four rows of pits, anticlockwise relay sowing, paired-column capture.",
  },
  {
    slug: "mozambique",
    name: "Mozambique",
    flag: "🇲🇿",
    region: "Southern Africa",
    blurb:
      "Ntxuva (M’pale) is a Mozambican four-row sowing game closely related to Tsoro.",
  },
  {
    slug: "zambia-malawi",
    name: "Zambia & Malawi",
    flag: "🇿🇲",
    region: "Southern Africa",
    blurb:
      "Nsolo and Nchombwa share family with Tsoro but use distinct capture rules.",
  },
  {
    slug: "south-africa",
    name: "South Africa",
    flag: "🇿🇦",
    region: "Southern Africa",
    blurb:
      "Moruba is played on a much larger 4×12 board and is won by the player with the highest capture total.",
  },
  {
    slug: "uganda",
    name: "Uganda",
    flag: "🇺🇬",
    region: "East Africa",
    blurb:
      "Omweso allows free opening setups and recycles captured counters back into play.",
  },
  {
    slug: "ghana",
    name: "Ghana",
    flag: "🇬🇭",
    region: "West Africa",
    blurb:
      "Oware Abapa is the classic two-row mancala with 2/3 capture and the 25-seeds-to-win goal.",
  },
  {
    slug: "nigeria",
    name: "Nigeria",
    flag: "🇳🇬",
    region: "West Africa",
    blurb:
      "Ayo Ọlọ́pọ́n exists in many family variants; the documented version captures on a final pit of exactly four.",
  },
  {
    slug: "bao",
    name: "Bao (Tanzania, Zanzibar, Kenya)",
    flag: "🇹🇿",
    region: "East Africa",
    blurb:
      "Bao is a much deeper four-row game with reserves, compulsory captures, and two phases.",
  },
];

export function getCountry(slug) {
  return COUNTRIES.find((c) => c.slug === slug);
}

export function getRulesetsForCountry(slug) {
  const group = COUNTRY_GROUPS.find((g) => g.slug === slug);
  if (!group) return [];
  return group.rulesetIds.map((id) => RULESETS.find((r) => r.id === id)).filter(Boolean);
}

export { STATUS };
